"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetStyle = exports.GlobalStyles = void 0;
const styled_components_1 = require("styled-components");
exports.GlobalStyles = (0, styled_components_1.createGlobalStyle) `
  body {
    color: #1e2120;
    font-family: ProximaNova, Roboto, Arial, Helvetica;
    font-size: 16px;
    line-height: 115%;
    font-weight: normal;
    min-height: 100vh;
    //overflow: hidden;
    width: 100%;
    text-rendering: optimizeLegibility;
    font-smooth: always;
    -webkit-font-smoothing: antialiased;
    scroll-behavior: smooth;
    a {
      color: #1e2120;
    }
    h2 a {
      color: #1e2120;
      text-decoration: none;
      position: relative;
      &:after {
          content: '';     
          width: 100%;
          position: absolute;
          left: 0;
          bottom: 0px;
      
          border-width: 0 0 1px;
          border-style: solid;
          border-color: #1e2120;
      }
    }
  }
  `;
exports.ResetStyle = (0, styled_components_1.createGlobalStyle) `
/* Box sizing rules */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* Remove default padding */
ul[class],
ol[class] {
  padding: 0;
}

/* Remove default margin */
body,
h1,
h2,
h3,
h4,
p,
ul[class],
ol[class],
li,
figure,
figcaption,
blockquote,
dl,
dd {
  margin: 0;
}

/* Remove list styles on ul, ol elements with a class attribute */
ul[class],
ol[class] {
  list-style: none;
}

/* A elements that don't have a class get default styles */
a:not([class]) {
  text-decoration-skip-ink: auto;
}

/* Make images easier to work with */
img {
  max-width: 100%;
  display: block;
}

/* Natural flow and rhythm in articles by default */
article > * + * {
  margin-top: 1em;
}

/* Inherit fonts for inputs and buttons and reset margins for safari and firefox */
input,
button,
textarea,
select {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  margin: 0; /* 2 */
}

input,
textarea {
  line-height: 1.15; /* 1 */
}

/* Remove all animations and transitions for people that prefer not to see them */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
`;
//# sourceMappingURL=styledGlobal.js.map